import { UserDto } from '../../user/dtos/user.dto';

export class LoginResponseDto {

  user: UserDto;

}
